<template>
  <v-container fluid>
    <v-row class="device_details" :class="!$route.params.deviceId ? '' : 'pl-3 pr-3'">
      <v-col cols="12" class="pa-0">
        <v-toolbar class="add-opacity" color="backgroundLight" :flat="true">
          <v-toolbar-title v-if="!$route.params.deviceId" class="title primaryGrey--text">
            <router-link :to="`/asset/${deviceId}`">
              <v-icon class="mr-3" small color="primaryGrey">mdi-open-in-new</v-icon
              >{{ $t("common.labels.openAsPage") }}
            </router-link>
          </v-toolbar-title>
          <v-toolbar-title v-if="$route.params.deviceId" class="title primaryGrey--text">
            <router-link :to="`/assets`">
              <v-icon class="mr-3" color="primaryGrey">mdi-keyboard-backspace</v-icon>{{ $t("common.words.back") }}
            </router-link>
            <v-btn
              small
              color="vtblue"
              @click="
                dialog = true;
                overlay_type = 'snapshot';
              "
              dark
              fixed
              right
              fab
            >
              <v-icon small>mdi-file-export</v-icon>
            </v-btn>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row v-if="device_data" class="common-card-row">
      <v-col id="map-parent-div" cols="12" md="8" class="pr-md-6 mb-0">
        <v-row>
          <v-col cols="12" class="common-card-col">
            <v-row no-gutters class="text-h6 font-weight-bold titleLight--text">
              <v-col cols="8">
                {{ device_data.DeviceName }}

                <v-icon
                  v-if="$route.params.deviceId"
                  color="primary"
                  class="pl-2 pb-1 pointer"
                  :title="edit_device_details"
                  @click="
                    dialog = true;
                    overlay_type = 'edit';
                  "
                  small
                  >mdi-pencil</v-icon
                >
                <router-link class="no-style" target="_blank" to="/powercoil_alerts">
                  <v-icon color="vtred" class="pl-2 pb-1 pointer" :title="manage_alerts" small>mdi-bell-plus</v-icon>
                </router-link>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <div v-if="device_data.CurrentLat" class="d-flex mt-1 text-caption primaryGrey--text">
                  <div>
                    <v-icon class="mr-1" color="primary" small>mdi-latitude</v-icon>{{ device_data.CurrentLat }}
                  </div>
                  <div class="ml-3">
                    <v-icon class="mr-1" color="primary" small>mdi-longitude</v-icon>{{ device_data.CurrentLng }}
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-3">
              <v-col
                cols="4"
                class="mb-3 font-weight-bold titleLight--text"
                v-for="(data, index) in page_content.device_details"
                :key="index"
              >
                <div class="text-caption">
                  {{ data.label }}
                </div>
                <v-icon small v-if="data.icon && device_data[data.value]">{{ data.icon }}</v-icon>
                <span v-else-if="data.type == 'datetime'">{{ device_data[data.value] | date }}</span>
                <span v-else-if="data.type == 'date'">{{ $dateFormat(device_data[data.value]) }}</span>
                <span v-else>
                  {{ device_data[data.value] || "-" }}
                </span>
                <span v-if="data.suffix && device_data[data.value]">{{ data.suffix }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="pt-3">
          <v-col cols="12" md="6" class="pa-0 pr-md-3">
            <v-col class="common-card-col font-weight-bold titleLight--text">
              {{ $t("views.Asset.latestMessage.title") }}
              -
              <span class="text-body-2">{{ device_data["LastMessageTime"] | date }}</span>
              <v-col class="pl-0 pb-0" cols="12" v-for="(data, index) in page_content.latest_message" :key="index">
                <div
                  class="d-flex justify-space-between align-center"
                  v-if="!data.show || (data.show && device_data[data.show.field] == data.show.value)"
                >
                  <div class="width-50 text-caption">
                    {{ data.label }}
                  </div>
                  <div>
                    <v-icon small v-if="data.icon">{{ data.icon }}</v-icon>
                    <span v-for="(coldata, idx) in data.values" :key="idx"
                      ><span v-if="data.type == 'datetime'">{{ device_data[coldata] | date }}</span>
                      <span v-if="data.type == 'date'">{{ $dateFormat(device_data[coldata]) }}</span>
                      <span v-else :class="`${data.colors[idx]}--text`">
                        {{ device_data[coldata] }}
                      </span>
                      <span class="text-caption" v-if="data.suffix && device_data[coldata]">{{ data.suffix }}</span
                      ><span v-if="idx != data.values.length - 1"> /</span></span
                    ><span v-if="data.type == 'datetime'">{{ device_data[data.value] | date }}</span>
                    <span v-if="data.type == 'date'">{{ $dateFormat(device_data[data.value]) }}</span>
                    <span v-else>
                      {{ device_data[data.value] }}
                    </span>
                    <span class="text-caption font-weight-light" v-if="data.helptext">{{ data.helptext }}</span>
                    <span class="text-caption" v-if="data.suffix && device_data[data.value]">{{ data.suffix }}</span>
                  </div>
                </div>
              </v-col>
            </v-col>
          </v-col>
          <v-col cols="12" md="6" class="pa-0">
            <v-col class="common-card-col font-weight-bold titleLight--text">
              {{ $t("views.Asset.calculatedReadings.title") }}
              <v-col cols="12" class="pl-0 pb-0" v-for="(data, index) in page_content.calculated_readings" :key="index">
                <div class="d-flex justify-space-between align-center">
                  <div class="width-50 text-caption">{{ data.label }}</div>
                  <div class="pr-4">
                    <v-icon small v-if="data.icon">{{ data.icon }}</v-icon>
                    <span v-for="(coldata, idx) in data.values" :key="idx"
                      ><span v-if="data.type == 'datetime'">{{ device_data[coldata] | date }}</span>
                      <span v-if="data.type == 'date'">{{ $dateFormat(device_data[coldata]) }}</span>
                      <span v-else :class="`${data.colors[idx]}--text`">
                        {{ device_data[coldata] }}
                      </span>
                      <span class="text-caption" v-if="data.suffix && device_data[coldata]">{{ data.suffix }}</span
                      ><span v-if="idx != data.values.length - 1"> /</span></span
                    ><span v-if="data.type == 'datetime'">{{ device_data[data.value] | date }}</span>
                    <span v-if="data.type == 'date'">{{ $dateFormat(device_data[data.value]) }}</span>
                    <span v-else>
                      {{ device_data[data.value] | round }}
                    </span>
                    <span class="text-caption font-weight-light" v-if="data.helptext">{{ data.helptext }}</span>
                    <span class="text-caption" v-if="data.suffix && device_data[data.value]">{{ data.suffix }}</span>
                  </div>
                </div>
              </v-col>
            </v-col>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4" class="pa-0 pt-3 pt-md-0">
        <v-col cols="12" class="common-card-col">
          <MapsVT
            :height="has_location ? '39vh' : '37vh'"
            :options="page_content.maps_config"
            :items="map_data"
            :center="get_center"
            :showRoute="!show_info_window"
            :hide_legends="show_info_window"
            :ber_data="update_ber"
          />
        </v-col>
      </v-col>
    </v-row>
    <v-row class="common-card-row pb-3">
      <v-col class="common-card-col">
        <PrimaryFiltersVT
          :list_filters="page_content.tabs"
          @filter_update="update_current_tab($event)"
          :current_tab="current_tab"
        ></PrimaryFiltersVT>
        <v-row no-gutters class="primaryDark--text">
          <v-col cols="12" v-if="!messages_list">
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" v-if="messages_list">
            <div class="mt-3" v-if="current_tab == 'Charts'">
              <div class="duration_select_div d-flex justify-space-between">
                <div class="d-flex align-center">
                  <div class="asset_select d-flex mx-4">
                    <v-autocomplete
                      color="primaryDark"
                      :items="devices_list"
                      :label="select_device_to_compare"
                      :disabled="show_comparision_data || duration.value > 7"
                      @change="get_comparsion_data($event)"
                      :item-text="comparision_label"
                      :item-value="comparision_value"
                      dense
                    ></v-autocomplete>
                    <div
                      class="mx-4 pointer mt-2 primary--text"
                      v-if="comparision_device_label"
                      @click="clear_compare()"
                    >
                      {{ $t("common.words.clear") }}
                    </div>
                  </div>
                  <div class="ml-2 pt-2">
                    <v-checkbox
                      v-if="device_data.CurrentLat && device_data.CurrentLng"
                      class="mt-0 show-ambient-temp"
                      :disabled="show_comparision_data || duration.value > 7"
                      dense
                      v-model="show_ambient_temp"
                      @change="fetch_ambient_temp_data()"
                      :label="include_ambient_temperature"
                    ></v-checkbox>
                  </div>
                  <div class="ml-2 pt-2">
                    <v-checkbox
                      class="mt-0 show-ambient-temp"
                      :disabled="!!device_id_comparision || show_ambient_temp || duration.value > 7"
                      dense
                      v-model="show_comparision_data"
                      :label="`Compare Previous ${this.duration.value <= 7 ? this.duration.stringValue : ''}`"
                    ></v-checkbox>
                  </div>
                </div>
                <div v-if="!(show_ambient_temp || show_comparision_data || duration.value > 7)">
                  <v-switch v-model="in_sync" label="Sync charts"></v-switch>
                </div>
                <div class="duration_select pt-3">
                  <v-select
                    :items="page_content.chart_select"
                    v-model="duration"
                    item-text="label"
                    item-value="value"
                    @change="fetch_stats_data"
                    return-object
                    height="30"
                    dense
                    outlined
                  ></v-select>
                </div>
              </div>
              <div v-if="!show_comparision_data">
                <LightningChart
                  v-if="duration.value <= 7 && new_chart_data && new_chart_data.length > 0"
                  :duration="`${duration.value}`"
                  :data="new_chart_data"
                  :config="page_content.chart_config1"
                  :in_sync="in_sync"
                  :new_data="prev_chart_data"
                  @update-interval="fetch_chart_data($event)"
                  :custom_period="true"
                />
                <LineRangeLightningChart
                  v-if="duration.value > 7 && updated_daily_stats_data && updated_daily_stats_data.length > 0"
                  :duration="duration.value"
                  :data="updated_daily_stats_data"
                  :config="page_content.chart_config1"
                  :in_sync="in_sync"
                />
              </div>
              <div v-else>
                <div v-for="(chart, index) in page_content.chart_config1" :key="`chart_${index}`">
                  <DiffAreaChart
                    v-if="
                      index == 1 &&
                      show_ambient_temp &&
                      new_chart_data &&
                      new_chart_data.length > 0 &&
                      new_chart_data[index]
                    "
                    :data="new_chart_data[index]"
                    :chartData="chart"
                    :duration="duration.value"
                  />
                  <ComboChart
                    v-if="index != 0 && new_chart_data && new_chart_data.length > 0 && new_chart_data[index]"
                    :data="new_chart_data[index]"
                    :chartData="chart"
                    :duration="duration.value"
                  />
                  <DiffChart
                    v-if="index == 0 && new_chart_data && new_chart_data.length > 0 && new_chart_data[index]"
                    :data="new_chart_data[index]"
                    :chartData="chart"
                    :duration="duration.value"
                  />
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div v-if="current_tab == 'Messages'">
              <div class="d-flex justify-center align-center">
                <div>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="on"
                        v-model="startDate"
                        append-icon="mdi-calendar"
                        readonly
                        :label="label_start_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="startDate"></v-date-picker>
                  </v-menu>
                </div>
                <div class="pl-4">
                  {{ $t("common.words.to") }}
                </div>
                <div class="pl-4">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="on"
                        v-model="endDate"
                        append-icon="mdi-calendar"
                        readonly
                        :label="label_end_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="endDate"></v-date-picker>
                  </v-menu>
                </div>
                <div class="pl-5">
                  <v-btn
                    :loading="is_loading"
                    :disabled="is_loading"
                    color="primary"
                    small
                    dark
                    @click="get_message_list"
                  >
                    {{ $t("common.words.search") }}
                  </v-btn>
                </div>
              </div>
              <v-card flat>
                <v-card-text class="pa-0">
                  <DataTableVT
                    :headers="page_content.messages_table"
                    sort_by="Timestamp"
                    :items_list="messages_list"
                    :no_search="no_search"
                    :loading="is_loading"
                  /> </v-card-text
              ></v-card>
            </div>
          </v-col>
          <v-col cols="12">
            <div v-if="current_tab == 'EVAnalysis'">
              <div class="d-flex justify-center align-center">
                <EVModelEditDetails :device_id="device_id" :device_data="device_data"></EVModelEditDetails>
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <div v-if="current_tab == 'HPAnalysis'">
              <div class="d-flex justify-center align-center">
                <HPModelEditDetails :device_id="device_id" :device_data="device_data"></HPModelEditDetails>
              </div>
            </div>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters v-if="current_tab == 'Health'">
              <v-col cols="12" class="pa-4">
                <v-row v-if="formatted_usage_data" no-gutters>
                  <v-col cols="10" class="border-right">
                    <div class="py-2 font-weight-bold">Transformer Usage and Heath</div>
                    <LineChart
                      :data="formatted_usage_data"
                      :chartData="page_content.health_chart"
                      :from_min="from_min"
                      :show_events="from_min"
                      :events_data="events_data"
                    />
                  </v-col>
                  <v-col cols="2">
                    <div
                      class="d-flex justify-space-between my-1 px-2"
                      v-for="(item, index) in page_content.life_lost_stats"
                      :key="`${item.value}_${index}`"
                    >
                      <div class="ma-1">
                        <div class="text-caption">
                          {{ item.label }}
                          <TooltipVT v-if="item.tooltip" :text="item.tooltip"></TooltipVT>
                        </div>
                        <div class="primaryDark--text text-h6">
                          {{
                            item.type != "string"
                              ? $numberWithCommas(parseFloat(life_lost_data[0][item.value]).toFixed(3))
                              : life_lost_data[0][item.value]
                          }}
                        </div>
                      </div>
                      <!-- <div class="ma-1 mr-0">
                          <v-chip
                            class="opaque-img px-4 py-7"
                            :color="`${item.color} lighten-4`"
                            label
                            :text-color="item.color"
                          >
                            <v-icon>{{ item.icon }}</v-icon>
                          </v-chip>
                        </div> -->
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-overlay class="layering" :value="dialog">
      <v-card
        :light="!this.$vuetify.theme.dark"
        color="backgroundLight"
        style="width: 80vw; max-height: 80vh; overflow: auto"
      >
        <div v-if="overlay_type == 'snapshot'" class="download-btn mt-9">
          <v-btn color="vtblue" icon right @click="exportPDF">
            <v-icon>mdi-file-export</v-icon>
          </v-btn>
        </div>
        <div class="close-btn">
          <v-btn @click="closeDialog" fixed outlined color="primaryGrey" class="py-4" x-small>
            <v-icon small color="primaryGrey">mdi-close</v-icon>
          </v-btn>
        </div>
        <div
          v-if="overlay_type == 'snapshot'"
          class="pa-0"
          style="overflow: auto; height: 100%; max-width: 100%"
          ref="poisnapshot"
        >
          <AssetSnapshot></AssetSnapshot>
        </div>
        <EditAssetDetails
          @cancel="dialog = false"
          @save="updateAssetsDetails($event)"
          :asset_data="{
            item: device_data,
          }"
          v-if="device_data && overlay_type == 'edit'"
        />
      </v-card>
    </v-overlay>
  </v-container>
</template>

<script>
import axios from "axios";
import DataTableVT from "../components/DataTableVT";
import PrimaryFiltersVT from "../components/PrimaryFiltersVT";
import MapsVT from "../components/MapsVT";
import LineChart from "../components/LineChart";
import DiffChart from "../components/DiffChart";
import DiffAreaChart from "../components/DiffAreaChart";
import LightningChart from "../components/LightningChart";
import ComboChart from "../components/ComboChart";
import EditAssetDetails from "../components/EditAssetDetails";
import AssetSnapshot from "../components/AssetSnapshot";
import EVModelEditDetails from "../components/EVModelEditDetails";
import HPModelEditDetails from "../components/HPModelEditDetails";
import html2pdf from "html2pdf.js";
import { axios_get, axios_put } from "../services/vt_service";
import { trafo, weather } from "../services/powerdata";
import { isDate } from "moment";
import { content } from "../../config/assets.js";
import TooltipVT from "../components/TooltipVT";
import LineRangeLightningChart from "../components/LineRangeLightningChart";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];
const api_root = process.env["VUE_APP_ROOT_API"];

export default {
  props: ["deviceId"],
  watch: {
    device_id: function (newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        this.getDeviceDetails();
      }
    },
  },
  name: "Asset",
  components: {
    DataTableVT,
    PrimaryFiltersVT,
    MapsVT,
    AssetSnapshot,
    EVModelEditDetails,
    HPModelEditDetails,
    EditAssetDetails,
    LineChart,
    DiffChart,
    ComboChart,
    DiffAreaChart,
    LineRangeLightningChart,
    TooltipVT,
    LightningChart,
  },
  data: function () {
    return {
      label_start_date: this.$t("common.labels.startDate"),
      label_end_date: this.$t("common.labels.endDate"),
      include_ambient_temperature: this.$t("common.labels.includeAmbientTemperature"),
      select_device_to_compare: this.$t("common.labels.selectDeviceToCompare"),
      manage_alerts: this.$t("common.labels.manageAlerts"),
      edit_device_details: this.$t("common.labels.editDeviceDetails"),
      temp_min_max: {
        min: null,
        max: null,
      },
      in_sync: true,
      from_min: true,
      startDate: null,
      endDate: null,
      flat: true,
      no_search: true,
      network_error: false,
      page_content: null,
      stats_data: null,
      life_lost_data: null,
      messages_list: null,
      current_tab: "Charts",
      device_data: null,
      current_position: {},
      current_battery_icon: "battery-full",
      has_coordinates: false,
      chartData: [],
      new_stats_data: null,
      last_start_date: null,
      device_id: null,
      location_data: {},
      device_id_comparision: null,
      show_info_window: true,
      dialog: false,
      show_map_object: null,
      duration: null,
      stats_data_comparison: null,
      overlay_type: null,
      show_comparision_data: false,
      chartOptions: {
        chart: {
          title: "Device Signals",
          subtitle: "Messages received (last 7 days)",
        },
      },
      common_comparision_data: null,
      formatted_stats_data: null,
      formatted_stats_comparision_data: null,
      show_ambient_temp: false,
      ambient_temp_list: null,
      daily_stats_data: null,
      chartZoomed: null,
      ber_data: null,
      is_loading: false,
      trafo_data: null,
      scv_data: null,
      fetching_chart_data: false,
      devices_list: null,
      comparision_device_label: null,
    };
  },
  created() {
    this.page_content = content;
    this.device_id = this.$route.params.deviceId || this.deviceId;
    this.duration = this.page_content.chart_select[0];
  },
  methods: {
    async getDeviceDetails() {
      await this.getTrafoDeviceDetails();
      this.getDeviceData();
    },
    closeDialog() {
      this.dialog = false;
      this.overlay_type = "";
    },
    getDay(day) {
      return this.$config.days[day];
    },
    zommed(event) {
      if (this.in_sync) this.chartZoomed = event;
    },
    fetch_stats_data(e) {
      this.daily_stats_data = null;
      if (this.duration.value > 7) {
        this.clear_compare();
        this.show_ambient_temp = false;
        this.show_comparision = false;
        let d = new Date();
        d.setDate(d.getDate() - this.duration.value);
        this.get_daily_stats_data(this.deviceId || this.$route.params.deviceId, new Date(), d);
      }
    },
    update_current_tab(val) {
      this.current_tab = val;
    },
    validate_checkbox() {
      return this.device_id_comparision && this.show_ambient_temp;
    },
    get_missing_count(data) {
      var prev_seq = null;
      var last_valid_seq = null;
      var count_missing = 0;
      for (var i = data.length - 1; i >= 0; i--) {
        count_missing = 0;
        if (i != data.length - 1) {
          if (prev_seq != null && last_valid_seq != null && data[i].SeqNo != 0) {
            count_missing = ((data[i].SeqNo - 1) % 4096) - last_valid_seq;
          }
          if (data[i].SeqNo == 0) {
            count_missing = "-";
            data[i]["UpdatedSeqNo"] =
              data[i]["PacketType"] && data[i]["PacketType"].toLowerCase().includes("gprs") ? "GPRS" : "LTE";
          } else {
            data[i]["UpdatedSeqNo"] = data[i].SeqNo;
          }
        }
        prev_seq = data[i].SeqNo;
        if (data[i].SeqNo != 0) {
          last_valid_seq = data[i].SeqNo;
        }
        data[i]["CountMissing"] = count_missing;
      }
      data[data.length - 1]["CountMissing"] = 0;
      return data;
    },
    exportPDF() {
      //this.$store.commit("show_loader");
      var opt = {
        margin: [0.5, 0.5, 0.5, 0.5],
        filename: "poi_snapshot_" + new Date().toString() + ".pdf",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          dpi: 190,
          letterRendering: true,
        },
        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "p",
        },
        pagebreak: {
          mode: ["avoid-all", "css", "legacy"],
        },
      };
      html2pdf()
        .from(this.$refs.poisnapshot)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then(function () {
          //Customization
        })
        .save();
      window.setTimeout(() => {
        this.dialog = false;
        this.overlay_type = "";
        this.$store.commit("hide_loader");
      }, 1000);
    },
    async updateAssetsDetails(data) {
      this.dialog = false;
      this.network_error = false;
      let { DeviceID } = data;
      // Clean the null values from the data otherwise API will throw error
      Object.keys(data).forEach((key) => data[key] === null && delete data[key]);
      await axios_put(trafo.update_assets_details, { DeviceID }, data);
      this.device_data = { ...this.device_data, ...data };
      this.error_message = "Device Details Successfully Saved!";
      this.snackbar = true;
    },
    async getDeviceData() {
      const accessToken = await this.$auth.getTokenSilently();
      this.network_error = false;
      var self = this;
      const tenant = this.$auth.user[tenant_key]["tenant"];
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      let get_stats = axios.get(api_root + "/api/powerdata/device/chartdata/" + this.device_id, header);
      let get_messages = axios.get(api_root + "/api/powerdata/messages/device/" + this.device_id, header);
      axios
        .all([get_stats, get_messages])
        .then(
          axios.spread((...responses) => {
            self.stats_data = responses[0].data;
            self.formatted_stats_data = {};
            this.stats_data["Timestamp"].map((n, i) => {
              self.formatted_stats_data[n] = self.format_stats_data(self.stats_data, i);
            });
            self.messages_list = this.get_missing_count(responses[1].data);
            self.device_data["Small_Area"] && self.get_ber_data();
            // self.get_life_lost_data(self.device_id);
            //self.$store.commit("hide_loader");
            if (self.$route.query && self.$route.query.type && self.$route.query.type == "add") {
              self.dialog = true;
              self.overlay_type = "edit";
            }
          })
        )
        .catch((e) => {
          self.network_error = true;
          //self.$store.commit("hide_loader");
          console.log(e);
        });
    },
    async fetch_ambient_temp_data() {
      if (this.show_ambient_temp && !this.ambient_temp_list) {
        this.dialog = false;
        this.overlay_type = "";
        this.network_error = false;
        const response = await axios_get(weather.fetch_ambient_temp_data, {
          lat: this.device_data.CurrentLat,
          lng: this.device_data.CurrentLng,
        });
        let ambient_temp_list = response
          ? response.map((elem) => {
              elem.Timestamp = new Date(this.$epochConverter(elem.Timestamp)).toUTCString();
              return elem;
            })
          : [];
        this.stats_data["Timestamp"] = this.stats_data["Timestamp"].map((elem, indx) => {
          let d = new Date(elem);
          d.setMinutes(0);
          d.setSeconds(0);
          elem = d.toUTCString();
          let time_temp = ambient_temp_list.filter((elemt) => {
            return elemt.Timestamp == elem;
          });
          if (time_temp && time_temp.length > 0) {
            if (!this.stats_data["AmbientTemp"]) this.stats_data["AmbientTemp"] = [];
            this.stats_data["AmbientTemp"][indx] = time_temp[0].t;
          }
          return elem;
        });
        this.ambient_temp_list = ambient_temp_list;
        this.formatted_stats_data = {};
        this.stats_data["Timestamp"].map((n, i) => {
          this.formatted_stats_data[n] = this.format_stats_data(this.stats_data, i);
        });
      }
    },
    async get_message_list() {
      this.is_loading = true;
      this.dialog = false;
      this.overlay_type = "";
      this.network_error = false;
      const response = await axios_get(
        trafo.get_message_list,
        { device_id: this.device_id },
        {
          start_date: this.startDate,
          end_date: this.endDate,
        }
      );
      this.messages_list = this.get_missing_count(response);
      this.is_loading = false;
    },
    async getTrafoDeviceDetails() {
      this.network_error = false;
      if (this.$route.params && this.$route.params.deviceId) {
        this.no_search = false;
        this.$store.commit("clear_search");
        this.$store.commit("update_page_title", `Device / ${this.device_id}`);
      }
      const response = await axios_get(trafo.get_assets_data, { num_days: 1 });
      this.devices_list = response;
      return (this.device_data =
        response && response.length > 0 ? response.filter((elem) => elem.DeviceID == this.device_id)[0] : null);
    },
    async get_stats_data(id, event) {
      this.fetching_chart_data = true;
      this.network_error = false;
      let end_date = event[0] == "start" ? event[1] : null;
      let start_date = event[0] == "end" ? event[1] : null;
      let params = end_date ? { end_date: end_date } : {};
      if (start_date) params["start_date"] = start_date;
      const response = await axios_get(trafo.get_comparsion_data_chart, { id }, params);
      this.new_stats_data = response;
      this.fetching_chart_data = false;
    },
    async get_life_lost_data(id) {
      this.network_error = false;
      const response = await axios_get(trafo.get_life_lost_data, null, { device_id: id });
      this.life_lost_data = response;
    },
    async get_ber_data() {
      this.network_error = false;
      if (this.device_data["Small_Area"]) {
        const response = await axios_get(trafo.get_ber_data, { areaId: this.device_data["Small_Area"] });
        this.ber_data = response[0];
      }
    },
    async get_daily_stats_data(id, end_date, start_date) {
      this.network_error = false;
      let params = start_date && end_date ? { start_date, end_date } : {};
      const response = await axios_get(trafo.get_chart_data, { id }, params);
      this.daily_stats_data = response;
    },
    fetch_chart_data(event) {
      let d = event[1];
      if (!this.show_ambient_temp && !this.show_comparision_data && !this.device_id_comparision) {
        if (!this.fetching_chart_data && (!this.last_start_date || this.last_start_date.getTime() !== d.getTime())) {
          this.last_start_date = d;
          this.get_stats_data(this.deviceId || this.$route.params.deviceId, event);
        }
      }
    },
    async get_comparsion_data(id) {
      this.network_error = false;
      let response = await axios_get(trafo.get_comparsion_data_chart, { id });
      this.comparision_device_label = this.setDeviceComparisionLabel(
        this.devices_list.find((elem) => elem.DeviceID == id)
      );
      response["Timestamp"] = response["Timestamp"].map((elem) => {
        let d = new Date(elem);
        d.setMinutes(0);
        d.setSeconds(0);
        elem = d.toUTCString();
        return elem;
      });
      this.stats_data_comparison = response;
      this.filter_format_stats_data();
    },
    format_stats_data(stats_data, inx_tmp) {
      return stats_data["AmbientTemp"]
        ? {
            AmbientTemp: stats_data["AmbientTemp"][inx_tmp],
            Current0Max: stats_data["Current0Max"][inx_tmp],
            Current1Max: stats_data["Current1Max"][inx_tmp],
            Current2Max: stats_data["Current2Max"][inx_tmp],
            Current0Med: stats_data["Current0Med"][inx_tmp],
            Current1Med: stats_data["Current1Med"][inx_tmp],
            Current2Med: stats_data["Current2Med"][inx_tmp],
            Imbalance: stats_data["Imbalance"][inx_tmp],
            TemperatureMax: stats_data["TemperatureMax"][inx_tmp],
            TemperatureMed: stats_data["TemperatureMed"][inx_tmp],
            Timestamp: stats_data["Timestamp"][inx_tmp],
            TotalPower: stats_data["TotalPower"][inx_tmp],
          }
        : {
            Current0Max: stats_data["Current0Max"][inx_tmp],
            Current1Max: stats_data["Current1Max"][inx_tmp],
            Current2Max: stats_data["Current2Max"][inx_tmp],
            Current0Med: stats_data["Current0Med"][inx_tmp],
            Current1Med: stats_data["Current1Med"][inx_tmp],
            Current2Med: stats_data["Current2Med"][inx_tmp],
            Imbalance: stats_data["Imbalance"][inx_tmp],
            TemperatureMax: stats_data["TemperatureMax"][inx_tmp],
            TemperatureMed: stats_data["TemperatureMed"][inx_tmp],
            Timestamp: stats_data["Timestamp"][inx_tmp],
            TotalPower: stats_data["TotalPower"][inx_tmp],
          };
    },
    clear_compare() {
      this.stats_data_comparison = null;
      this.comparision_device_label = null;
      this.formatted_stats_comparision_data = null;
      this.formatted_stats_data = {};
      this.stats_data["Timestamp"].map((n, i) => {
        this.formatted_stats_data[n] = this.format_stats_data(this.stats_data, i);
      });
    },
    filter_format_stats_data() {
      this.formatted_stats_data = {};
      this.formatted_stats_comparision_data = {};
      this.common_comparision_data = this.stats_data_comparison["Timestamp"].filter((n, i) => {
        if (this.stats_data["Timestamp"].indexOf(n) !== -1) {
          let inx_tmp = this.stats_data["Timestamp"].indexOf(n);
          this.formatted_stats_data[n] = this.format_stats_data(this.stats_data, inx_tmp);
          this.formatted_stats_comparision_data[n] = this.format_stats_data(this.stats_data_comparison, i);
          return true;
        }
        return false;
      });
    },
    format_comparison_data: function (data) {
      let this_week_data = [];
      let last_week_data = [];
      let startDate = new Date();
      let endDate = new Date();
      endDate.setDate(startDate.getDate() - this.duration.value);
      let comparison_startDate = new Date();
      comparison_startDate.setDate(startDate.getDate() - 7);
      let comparison_endDate = new Date();
      comparison_endDate.setDate(endDate.getDate() - 7);
      let sorted_keys = Object.keys(data).sort((a, b) => {
        if (new Date(a) > new Date(b)) return 1;
        if (new Date(a) < new Date(b)) return -1;
        return 0;
      });
      for (let i = 0; i < sorted_keys.length; i++) {
        let timestmp = new Date(data[sorted_keys[i]]["Timestamp"]);
        let temp = JSON.parse(JSON.stringify(data[sorted_keys[i]]));
        temp["label"] = `${this.$config.days[timestmp.getDay()]}, ${timestmp.getHours()}Hrs`;
        if (timestmp <= startDate && timestmp >= endDate) {
          this_week_data.push(temp);
        } else if (timestmp <= comparison_startDate && timestmp >= comparison_endDate) {
          last_week_data.push(temp);
        }
      }
      return this.merge_array_objects(this_week_data, last_week_data, "label");
    },
    merge_array_objects: function (arr1, arr2, key) {
      let merged = [];

      for (let i = 0; i < arr1.length; i++) {
        merged.push({
          ...arr1[i],
          compare: arr2.find((itmInner) => itmInner[key] === arr1[i][key]),
        });
      }
      return merged;
    },
    update_chart_data: function (
      timestmp,
      obj,
      temprature_temp,
      consolidated_im_medc,
      consolidated_tp_medc,
      consolidated_im_maxc,
      consolidated_tp_maxc,
      temp_diff
    ) {
      if (this.show_comparision_data) {
        if (obj["compare"]) {
          if (temprature_temp)
            if (this.show_ambient_temp && this.ambient_temp_list) {
              temprature_temp.push([
                obj["label"],
                // obj["TemperatureMed"],
                obj["TemperatureMax"],
                obj["AmbientTemp"],
                // obj["compare"]["TemperatureMed"],
                obj["compare"]["TemperatureMax"],
              ]);
            } else {
              if (!this.temp_min_max.max || obj["TemperatureMax"] > this.temp_min_max.max)
                this.temp_min_max.max = obj["TemperatureMax"];
              if (obj["compare"]["TemperatureMax"] > this.temp_min_max.max)
                this.temp_min_max.max = obj["compare"]["TemperatureMax"];

              if (!this.temp_min_max.min || obj["TemperatureMax"] < this.temp_min_max.min)
                this.temp_min_max.min = obj["TemperatureMax"];
              if (obj["compare"]["TemperatureMax"] < this.temp_min_max.min)
                this.temp_min_max.min = obj["compare"]["TemperatureMax"];
              temprature_temp.push([
                obj["label"],
                // obj["TemperatureMed"],
                obj["TemperatureMax"],
                // obj["compare"]["TemperatureMed"],
                obj["compare"]["TemperatureMax"],
              ]);
            }
          consolidated_im_medc.push([
            obj["label"],
            obj["Imbalance"],
            obj["Current0Med"],
            obj["Current1Med"],
            obj["Current2Med"],
            obj["compare"]["Imbalance"],
            // obj["compare"]["Current0Med"],
            // obj["compare"]["Current1Med"],
            // obj["compare"]["Current2Med"],
          ]);
          consolidated_tp_medc.push([
            obj["label"],
            obj["TotalPower"],
            obj["Current0Med"],
            obj["Current1Med"],
            obj["Current2Med"],
            obj["compare"]["TotalPower"],
            // obj["compare"]["Current0Med"],
            // obj["compare"]["Current1Med"],
            // obj["compare"]["Current2Med"],
          ]);
          consolidated_im_maxc.push([
            obj["label"],
            obj["Imbalance"],
            obj["Current0Max"],
            obj["Current1Max"],
            obj["Current2Max"],
            obj["compare"]["Imbalance"],
            // obj["compare"]["Current0Max"],
            // obj["compare"]["Current1Max"],
            // obj["compare"]["Current2Max"],
          ]);
          consolidated_tp_maxc.push([
            obj["label"],
            obj["TotalPower"],
            obj["Current0Max"],
            obj["Current1Max"],
            obj["Current2Max"],
            obj["compare"]["TotalPower"],
            // obj["compare"]["Current0Max"],
            // obj["compare"]["Current1Max"],
            // obj["compare"]["Current2Max"],
          ]);
        }
      } else {
        if (this.show_ambient_temp && this.ambient_temp_list)
          temprature_temp.push([timestmp, obj["TemperatureMed"], obj["TemperatureMax"], obj["AmbientTemp"]]);
        else temprature_temp.push([timestmp, obj["TemperatureMed"], obj["TemperatureMax"]]);
        temp_diff && temp_diff.push([timestmp, obj["TemperatureMax"], obj["AmbientTemp"]]);
        consolidated_im_medc.push([
          timestmp,
          obj["Imbalance"],
          obj["Current0Med"],
          obj["Current1Med"],
          obj["Current2Med"],
        ]);
        consolidated_tp_medc.push([
          timestmp,
          obj["TotalPower"],
          obj["Current0Med"],
          obj["Current1Med"],
          obj["Current2Med"],
        ]);
        consolidated_im_maxc.push([
          timestmp,
          obj["Imbalance"],
          obj["Current0Max"],
          obj["Current1Max"],
          obj["Current2Max"],
        ]);
        consolidated_tp_maxc.push([
          timestmp,
          obj["TotalPower"],
          obj["Current0Max"],
          obj["Current1Max"],
          obj["Current2Max"],
        ]);
      }
    },
    format_chart_data(params, stats_obj, compare = false, isDate = true) {
      let temp = [];
      let count = 0;
      stats_obj &&
        params.forEach((paramObj, indx) => {
          let tempp = [];
          paramObj.map((param) => {
            let temp = [];
            stats_obj["Timestamp"].map((elem, i) => {
              if (stats_obj[param.id] && stats_obj[param.id][i] != 0)
                this.show_comparision_data
                  ? temp.push({
                      key: isDate ? new Date(elem) : elem,
                      value: stats_obj[param.id][i],
                    })
                  : temp.push({
                      x: isDate ? new Date(elem) : elem,
                      y: stats_obj[param.id][i],
                    });
            });
            if (temp.length > 0) {
              count = temp.length;
              !this.show_ambient_temp && indx == 1
                ? tempp.push(null)
                : tempp.push({
                    id: compare ? `${param.id}_compare` : param.id,
                    label: compare
                      ? this.stats_data_comparison && this.comparision_device_label
                        ? `${this.comparision_device_label} ${param.label}`
                        : `Last Week ${param.label}`
                      : param.label,
                    type: param.type,
                    suffix: param.suffix,
                    values: temp,
                  });
            }
          });
          if ((!this.show_ambient_temp && indx == 1) || count == 0) tempp = null;
          temp.push(tempp);
        });
      return temp;
    },
    format_daily_chart_data(params, stats_obj) {
      let temp = [];
      let count = 0;
      stats_obj &&
        params.forEach((paramObj, indx) => {
          let tempp = paramObj.map((param) => {
            let temp = { range: [], values: [] };
            stats_obj["Timestamp"].map((elem, i) => {
              this.keyValue(stats_obj, param.id, i, elem, temp, param.min, param.max);
            });
            count = temp.values.length > 0 ? temp.values.length : count;
            return !this.show_ambient_temp && indx == 1
              ? null
              : {
                  id: param.id,
                  label: param.label,
                  type: param.type,
                  values: temp.values,
                  range: temp.range,
                };
          });
          if (count == 0 || (!this.show_ambient_temp && indx == 1)) tempp = null;
          temp.push(tempp);
        });
      return temp;
    },
    keyValue(obj, id, i, elem, temp, min, max) {
      if (obj[id] && obj[id][i]) {
        temp.range.push({
          x: isDate ? new Date(elem) : elem,
          yMin: obj[min][i],
          yMax: obj[max][i],
        });
        temp.values.push({
          x: isDate ? new Date(elem) : elem,
          y: obj[id][i],
        });
      }
    },
    setDeviceComparisionLabel(item) {
      if ((!item.DeviceName && !item.AssetID) || !item) return "No Asset ID or Device Name";
      return `${item.DeviceName} - ${item.AssetID}`;
    },
  },
  computed: {
    comparision_label() {
      return (item) => {
        if (!item.DeviceName && !item.AssetID) return "No Asset ID or Device Name";
        return `${item.DeviceName} - ${item.AssetID}`;
      };
    },
    comparision_value() {
      return (item) =>
        item.DeviceStatus && item.DeviceStatus.toLowerCase().includes("installed") ? item.DeviceID : null;
    },
    new_chart_data() {
      let params = JSON.parse(JSON.stringify(this.page_content.stats_chart));
      let compare_params = [
        [
          {
            id: "TemperatureMax",
            type: "line",
            label: "Temperature Max",
            suffix: "°C",
          },
        ],
        [],
        [
          {
            id: "Imbalance",
            type: "bar",
            label: "Imbalance",
            suffix: "%",
          },
        ],
        [
          {
            id: "TotalPower",
            type: "bar",
            label: "Total Power",
            suffix: "kVA",
          },
        ],
        [
          {
            id: "Imbalance",
            type: "bar",
            label: "Imbalance",
            suffix: "%",
          },
        ],
        [
          {
            id: "TotalPower",
            type: "bar",
            label: "Total Power",
            suffix: "kVA",
          },
        ],
      ];
      if (this.show_ambient_temp && this.ambient_temp_list)
        params[0].push({
          id: "AmbientTemp",
          type: "line",
          label: "Ambient Temp",
          suffix: "°C",
        });
      let stats_data = {};
      let keys = [
        "TemperatureMed",
        "TemperatureMax",
        "Current0Max",
        "Current1Max",
        "Current2Max",
        "Current0Med",
        "Current1Med",
        "Current2Med",
        "Imbalance",
        "TotalPower",
        "Timestamp",
      ];
      let isDateFormat = true;
      let temp = {};
      let comparison_data = {};
      if (this.duration.value <= 7 && this.show_comparision_data) {
        params[0].shift();
        isDateFormat = false;
        let today = new Date();
        let duration = new Date();
        duration.setTime(today.getTime() - this.duration.value * 24 * 60 * 60 * 1000);
        let compare_day = new Date();
        compare_day.setTime(today.getTime() - 7 * 24 * 60 * 60 * 1000);
        let compare_duration = new Date();
        compare_duration.setTime(compare_day.getTime() - this.duration.value * 24 * 60 * 60 * 1000);
        this.stats_data["Timestamp"].forEach((elem, indx) => {
          if (new Date(elem) > duration) {
            keys.forEach((key) => {
              if (!stats_data[key]) stats_data[key] = [];
              if (key == "Timestamp")
                stats_data[key].push(
                  `${this.$config.days[new Date(this.stats_data[key][indx]).getDay()]} ${new Date(
                    this.stats_data[key][indx]
                  ).getHours()}Hrs`
                );
              else stats_data[key].push(this.stats_data[key][indx]);
            });
          } else if (compare_duration <= new Date(elem) && new Date(elem) <= compare_day) {
            keys.forEach((key) => {
              if (!comparison_data[key]) comparison_data[key] = [];
              if (key == "Timestamp")
                comparison_data[key].push(
                  `${this.$config.days[new Date(this.stats_data[key][indx]).getDay()]} ${new Date(
                    this.stats_data[key][indx]
                  ).getHours()}Hrs`
                );
              else comparison_data[key].push(this.stats_data[key][indx]);
            });
          }
        });
        comparison_data = this.format_chart_data(compare_params, comparison_data, true, false);
      } else {
        stats_data = this.stats_data;
      }
      temp = this.format_chart_data(params, stats_data, false, isDateFormat);
      if (this.duration.value <= 7 && this.stats_data_comparison) {
        comparison_data = this.format_chart_data(params, this.stats_data_comparison, true, true);
      }
      if (this.duration.value <= 7 && comparison_data && Object.keys(comparison_data).length !== 0) {
        temp = temp.map((key, indx) => {
          if (!key || !comparison_data[indx]) return null;
          key = key.concat(comparison_data[indx]);
          return key;
        });
      }
      return this.duration.value <= 7 ? temp : null;
    },
    prev_chart_data() {
      let params = JSON.parse(JSON.stringify(this.page_content.stats_chart));
      let stats_data = {};
      let isDateFormat = true;
      let temp = {};
      stats_data = this.new_stats_data ? JSON.parse(JSON.stringify(this.new_stats_data)) : null;
      temp = stats_data ? this.format_chart_data(params, stats_data, false, isDateFormat) : null;
      return this.show_ambient_temp || this.show_comparision_data || !stats_data || !this.new_stats_data ? [] : temp;
    },
    updated_daily_stats_data() {
      let params = JSON.parse(JSON.stringify(this.page_content.daily_stats_chart));
      let temp;
      if (this.duration.value > 7 && this.daily_stats_data) {
        temp = this.format_daily_chart_data(params, this.daily_stats_data);
      }
      return this.duration.value > 7 ? temp : null;
    },
    computed_location_details() {
      let temp_obj = JSON.parse(JSON.stringify(this.device_data));
      if (this.location_data) {
        let current_location = this.location_data[this.device_data.CurrentPOI];
        if (current_location) {
          temp_obj["LocationID"] = current_location["LocationID"];
          temp_obj["FlowRate"] = current_location["FlowRate"];
          temp_obj["FluidAssets"] = current_location["FluidAssets"];
          temp_obj["FullName"] = current_location["FullName"];
          temp_obj["StaticAssets"] = current_location["StaticAssets"];
          temp_obj["TotalAssets"] = current_location["TotalAssets"];
          temp_obj["Utilisation"] = current_location["Utilisation"];
          temp_obj["LocationCategory"] = current_location["LocationCategory"];
        }
      }
      return temp_obj;
    },
    has_location: function () {
      return this.computed_location_details.CurrentLat && this.computed_location_details.CurrentLng ? true : false;
    },
    map_data: function () {
      return this.computed_location_details.CurrentLat ? [this.computed_location_details] : [];
    },
    get_center: function () {
      return this.map_data
        ? new window.google.maps.LatLng(
            this.computed_location_details.CurrentLat,
            this.computed_location_details.CurrentLng
          )
        : null;
    },
    update_ber: function () {
      return this.ber_data && this.current_tab == "HPAnalysis" ? this.ber_data : null;
    },
    events_data() {
      return this.device_data && this.device_data.InstallationDate
        ? [
            {
              id: "00001",
              key: this.device_data.InstallationDate,
              info: "Installation Date",
            },
          ]
        : null;
    },
    formatted_usage_data: function () {
      let params = {
        Feqa: "line",
      };
      // { usage: "area", lifeLost: "area", feqa: "line" };
      let temp = [];
      this.life_lost_data &&
        this.life_lost_data.map((e) => {
          Object.keys(params).map((p, i) => {
            if (p) {
              temp[i] = !temp[i]
                ? {
                    id: p,
                    label: p.toUpperCase(),
                    type: params[p],
                    values: [],
                  }
                : temp[i];
              temp[i].values.push({
                key: new Date(e.Month),
                value: e[p],
              });
            }
          });
        });
      return this.life_lost_data && temp.length > 0 ? temp : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.map {
  height: 100%;
  width: 100%;
}

.device_details .title {
  font-size: 0.75rem !important;
  font-family: Trade Gothic Regular !important;
}

.border-bottom {
  border-bottom: 1px solid var(--v-restingOutline-base);
}

.border-right {
  border-right: 1px solid var(--v-restingOutline-base);
}

.duration_select_div {
  .duration_select {
    width: 9em;
    margin-right: 1em;
  }

  .asset_select {
    width: 25em;

    .v-input {
      max-width: 80%;
    }
  }

  ::v-deep.show-ambient-temp {
    label {
      margin-bottom: 0 !important;
    }
  }
}

::v-deep .export-div {
  top: 25px;
  right: 2rem;
}

::v-deep .width-50 {
  width: 50%;
  display: inline-block;
}

.close-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding-top: 1em;
  padding-right: 3em;
}

.download-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}

.pointer {
  cursor: pointer;
}
</style>
